// src/app/router/adminRoute.js
import { useAuth } from '@/context/AuthContext';
import { Navigate, Outlet } from 'react-router-dom';

const AdminRoute = () => {
  const { user, role, isLoading } = useAuth();

  if (isLoading) return <div>Chargement...</div>;
  if (!user) return <Navigate to="/login" />;
  if (role !== 'admin') return <Navigate to="/" />;

  return <Outlet />;  // ← retourne Outlet au lieu de children
};

export default AdminRoute;